import entity from './entity';

import ReduxRestEntity from '../../../../utils/reduxRestEntity';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  ...ReduxRestEntity.initialState,
};


const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
